export default "__VITE_ASSET__DC70kL_Y__"